import React from 'react'
import { useCallback, useEffect, useMedia } from 'sb-hooks'
import { ModalVisibilityProps, modalVisibility, openModal } from 'sb-modal'
import { snowplow } from 'common/helpers'

import { openReviewModal } from 'compositions/modals/review/ReviewModal/ReviewModal'

import ReviewLatestScentModalView from '../ReviewLatestScentModalView/ReviewLatestScentModalView'


export const ReviewLatestScentModal: React.FunctionComponent<ModalVisibilityProps & Review.ReviewLatestScentModalProps> = (props) => {
  const { product, closeModal, onClose } = props
  const { id: productId } = product
  const { isMobile } = useMedia()

  const handleRate = useCallback((rating: Review.Rating) => {
    closeModal()

    openReviewModal({
      productId,
      initialRating: rating,
      // to save rating
      saveInitialRating: true,
      placement: 'popup',
    })
  }, [ closeModal, productId ])

  useEffect(() => {
    snowplow.track('Review popup')
  }, [])

  useEffect(() => {
    // the modal is mobile only, so we need to close it otherwise
    if (!isMobile) {
      handleRate(0)
    }
  }, [ isMobile, handleRate ])

  if (!isMobile) {
    return null
  }

  return (
    <ReviewLatestScentModalView
      product={product}
      onRate={handleRate}
      onRemindLater={onClose}
      onClose={onClose}
    />
  )
}


export const openReviewLatestScentModal = (props: Review.ReviewLatestScentModalProps) =>
  openModal('reviewLatestScent', props)


export default modalVisibility('reviewLatestScent', ReviewLatestScentModal)
